module.exports = __webpack_public_path__ + "img/fig18.7a46faf4.jpg";